import styled from 'styled-components';

export const AlertButton = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    display: flex;
    line-height: 20px;
    color: ${p => p.theme.icons.tertiary};
    margin: 20px 0;
    padding: 10px 20px;
    border-radius: 4px;
    border: 1px solid ${p => p.theme.lines.tertiary};
    cursor: pointer;
  }

  svg {
    fill: ${p => p.theme.icons.tertiary};
    width: 20px !important;
    height: 20px !important;
    margin-right: 5px;
  }
`;
